import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

export default function AdminGamification() {
  return (
    <Group direction="vertical" gap={8}>
      <Heading variant="heading4">Gamification</Heading>
      <Accordion size="large" heading="What is gamification? How do I set it up?">
        <BodyText variant="large">
          Gamification is Business Traveller's way to help encourage your staff to make smart, cost-conscious decisions on work trips.
        </BodyText>
        <br />
        <BodyText variant="large">
          You can set this up by:
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large">Visiting Travel Policy Page under Settings</BodyText>
            </li>
            <li>
              <BodyText variant="large">Set a credit rate</BodyText>
            </li>
            <li>
              <BodyText variant="large">Save</BodyText>
            </li>
          </Group>
        </ol>
        <BodyText variant="large">
          Once this is set up, employees who spend under the allocated budget can earn Luxury Escapes credit for their personal use, based on your chosen credit rate.
        </BodyText>
        <br />
        <BodyText variant="large">
          For example, with a credit rate of 50%, if an employee spends only $200 out of a $300 budget, they receive $50 in Luxury Escapes credit, while $50 is returned to your organisation. It's a win-win for both the employee and your organisation.
        </BodyText>
      </Accordion>
      <Accordion size="large" heading="If an employee leaves the business, what happens to their credits?">
        <BodyText variant="large">
          Credits earned by employees as rewards for spending under budget are assigned to the traveller's personal Luxury Escapes account. If an employee leaves the business, their accrued credits remain accessible through their personal account.
        </BodyText>
        <br />
        <BodyText variant="large">
          These credits are associated with the individual traveller's profile and are not affected by their employment status. As such, departing employees retain ownership of the credits they have earned and can continue to utilise them for future personal travel bookings.
        </BodyText>
      </Accordion>
      <Accordion size="large" heading="Do all staff need to create a Luxury Escapes personal account?">
        <BodyText variant="large">
          Yes, to access the full range of perks and features offered by Business Traveller, all staff members are required to create a personal account with Luxury Escapes. Here's how it works:
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">New Accounts:</BodyText>
              <BodyText variant="large"> If an employee does not already have a Luxury Escapes account, they can easily create one using their email address. This personal account will be separate from their work profile, ensuring that any credits earned remain accessible to them even if they leave the company.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Existing Accounts:</BodyText>
              <BodyText variant="large"> Employees who already have an existing Luxury Escapes account can simply link it to their Business Traveller profile during the onboarding process. This allows them to seamlessly access all perks and benefits associated with Business Traveller without the need to create a new account.</BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
    </Group>
  )
}
